import actionCreatorFactory from 'typescript-fsa';
import { ApiFieldError } from 'src/types';

export const actionCreator = actionCreatorFactory(
  `@@LENDSMARTMANAGER/DeclinedLOANAPPSADVISOR`
);
type APIError = ApiFieldError;
export const allDeclinedLoanAppsRequest = actionCreator('request');

export const allDeclinedLoanAppsRequestSuccess = actionCreator<any>('success');

export const allDeclinedLoanAppsRequestFail = actionCreator<APIError[]>('fail');

export const updateDeclinedLoanApps = actionCreator<any>('update');
export const _updateDeclinedAdvisorLoanAppsInStore = actionCreator<any>(
  'update-declined-store'
);

export const updateMultipleDeclinedLoanApps = actionCreator<any>(
  'update-multiple-declined-loanApps'
);
